import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { getAuthHeaders, fetchUser } from 'services/api';
import { setUserData, getUserData } from 'utils/encryption';
import { error, log } from 'utils/logger';

interface UserContextType {
    checkAuth: () => Promise<void>;
    userData: any;
}

const UserContext = createContext<UserContextType | undefined>(undefined);

export const UserProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [userData, setUserDataState] = useState<any>(getUserData());

    const checkUsersAuth = useCallback(async () => {
        try {
            log('Checking user auth status...');
            const user = await fetchUser();
            if (user) {
                log('User auth check response:', user);
                // Save the data (not the response object) after encryption
                setUserData(user);
                setUserDataState(user);
            }
        } catch (err: any) {
            error('Error checking user auth:', err);
        }
    }, []);

    useEffect(() => {
        // Check auth on every component mount (page reload)
        const headers = getAuthHeaders();
        if (headers) {
            checkUsersAuth();
        }
    }, [checkUsersAuth]);

    return (
        <UserContext.Provider value={{ 
            checkAuth: checkUsersAuth,
            userData
        }}>
            {children}
        </UserContext.Provider>
    );
};

export const useUser = () => {
    const context = useContext(UserContext);
    if (context === undefined) {
        throw new Error('useUser must be used within a UserProvider');
    }
    return context;
};
